import { IconButton, InputGroup, InputProps, InputRightElement } from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { useCallback, useState } from "react";
import { Input } from "./input";

type Props = {
  validations?: string[],
} & InputProps;

/* アイコンのクリックで入力値の表示/非表示を切り替えられるパスワード入力欄 */
export const PasswordInput = (props: Props) => {
  const [passwordView, setPasswordView] = useState(false);
  const onClickPasswordView = useCallback(() => {
    setPasswordView((view) => !view);
  }, []);

  return (
    <InputGroup>
      <Input
        autoComplete="new-password"
        {...props}
        type={passwordView ? 'text' : 'password'}
      />
      <InputRightElement>
        <IconButton
          aria-label='password_preview'
          onClick={onClickPasswordView}
          bg="transparent"
          icon={
            !passwordView ? <ViewIcon /> : <ViewOffIcon />
          }
        />
      </InputRightElement>
    </InputGroup>
  )
}
